import axios from 'axios'
import Utils from '@/common/Utils'

const url = `${process.env.VUE_APP_BASEPATH}/api`
const headers = { 'Content-Type': 'application/json' }

export default class LocationsService {
    static async uploadSepomexFile (importFile) {
        try {
            let formData = new FormData()
            formData.append('importFile', importFile)

            let { data } = await axios.post(`${url}/uploadSepomexFile`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async processFile (fileName) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/processFile/${fileName}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async compareColonies (stateCode) {
        try {
            let { data } = await axios.post(`${url}/compareColonies`, { stateCode: stateCode })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async searchData () {
        try {
            let { data } = await axios.post(`${url}/searchData`, { })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async getClients (postalCode) {
        try {
            let { data } = await axios.post(`${url}/getClients`, { postalCode: postalCode })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async clientsPostalCodeInvalid () {
        try {
            let { data } = await axios.post(`${url}/clientsPostalCodeInvalid`, { })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async locationsDiferences (resumeStates) {
        try {
            let { data } = await axios.post(`${url}/locationsDiferences`, { resumeStates: resumeStates })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async getLocationsInegi (stateCode) {
        try {
            let { data } = await axios.post(`${url}/getLocationsInegi`, { stateCode: stateCode })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async searchLocation (location) {
        try {
            let { data } = await axios.post(`${url}/searchLocation`, { location: location })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async relateInegiCode (location, cvegeo) {
        try {
            let { data } = await axios.post(`${url}/relateInegiCode`, { location: location, cvegeo: cvegeo })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async clientsLocations () {
        try {
            let { data } = await axios.post(`${url}/clientsLocations`, {})
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async loadStates () {
        try {
            let { data } = await axios.post(`${url}/loadStates`, {})
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async addNewPostalCodes (stateCode) {
        try {
            let { data } = await axios.post(`${url}/addNewPostalCodes`, { stateCode: stateCode })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async relateLocation (colonyId, location) {
        try {
            let { data } = await axios.post(`${url}/relateLocation`, { location: location, colonyId: colonyId })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async deleteLocation (colonyId) {
        try {
            let { data } = await axios.post(`${url}/deleteLocation`, { colonyId: colonyId })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async assignInegiCodes (stateCode) {
        try {
            let { data } = await axios.post(`${url}/assignInegiCodes`, { stateCode: stateCode })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async assignLocationsCodes (stateCode) {
        try {
            let { data } = await axios.post(`${url}/assignLocationsCodes`, { stateCode: stateCode })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }
}
